import { useEffect, useState } from 'react';

const KEY = 'ssc_mode';

// Full-screen operator ("SSC") mode: hides the app sidebar + header.
export function useSscMode() {
  const [on, setOn] = useState(() => { try { return sessionStorage.getItem(KEY) === '1'; } catch { return false; } });
  useEffect(() => {
    const sync = () => { try { setOn(sessionStorage.getItem(KEY) === '1'); } catch { setOn(false); } };
    window.addEventListener('ssc-mode', sync);
    return () => window.removeEventListener('ssc-mode', sync);
  }, []);
  return on;
}

export function setSscMode(v) {
  try {
    if (v) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY);
    window.dispatchEvent(new Event('ssc-mode'));
    if (v && document.documentElement.requestFullscreen && !document.fullscreenElement) document.documentElement.requestFullscreen().catch(() => {});
    if (!v && document.fullscreenElement && document.exitFullscreen) document.exitFullscreen().catch(() => {});
  } catch { /* storage disabled */ }
}
